import React from 'react'
import {
  List,
  Datagrid,
  Edit,
  SimpleForm,
  TextField,
  EditButton,
  NumberField,
  Show,
  NumberInput,
  Filter,
  TextInput,
  DateInput,
  TabbedShowLayout,
  Tab,
  FileInput,
  FileField,
  ReferenceInput,
  AutocompleteInput,
  required,
} from 'react-admin'
import Icon from '@material-ui/icons/MoneyOff'
import HiddenUserInput from './HiddenUserInput'
import MultiDateField from '../fields/MultiDateField'
import Attachments from './Attachments'
import ResourceField from '../fields/ResourceField'
import nameFilterToQuery from '../utils/nameFilterToQuery'
export const ExpenseIcon = Icon

const ExpenseFilter = props => (
  <Filter {...props}>
    <TextInput source="bankTransaction.name_contains" label="Name" alwaysOn />
    <TextInput source="id_contains" label="ID" />
    <ReferenceInput
      label="Product"
      source="product.id"
      reference="Product"
      filterToQuery={nameFilterToQuery}
    >
      <AutocompleteInput />
    </ReferenceInput>
    <ReferenceInput
      label="Type"
      source="type.id"
      reference="ExpenseType"
      filterToQuery={nameFilterToQuery}
    >
      <AutocompleteInput />
    </ReferenceInput>
    <NumberInput label="Amount" source="bankTransaction.amount" />
    <TextInput source="bankTransaction.description_contains" label="Description" />
    <DateInput source="bankTransaction.date" label="Date" />
  </Filter>
)

export const ExpenseList = props => {
  return (
    <List {...props} filters={<ExpenseFilter />}>
      <Datagrid rowClick="show">
        <TextField source="bankTransaction.name" label="Name" />
        <TextField source="type.name" label="Type" />
        <NumberField
          label="Amount"
          source="bankTransaction.amount"
          options={{ style: 'currency', currency: 'USD' }}
        />
        <TextField source="bankTransaction.description" label="Description" />
        <MultiDateField source="bankTransaction.date" label="Date" />
        <EditButton />
      </Datagrid>
    </List>
  )
}

const ExpenseTitle = ({ record }) => {
  return <span>Expense {record ? `"${record.bankTransaction.name}"` : ''}</span>
}

export const ExpenseEdit = props => (
  <Edit title={<ExpenseTitle />} {...props}>
    <SimpleForm redirect="list">
      <TextInput source="bankTransaction.name" validate={required()} label="Name" />
      <ReferenceInput
        label="Type"
        source="type.id"
        reference="ExpenseType"
        filterToQuery={nameFilterToQuery}
        validate={required()}
      >
        <AutocompleteInput />
      </ReferenceInput>
      <NumberInput
        label="Amount"
        source="bankTransaction.amount"
        validate={required()}
      />
      <TextInput multiline source="bankTransaction.description" label="Description" />
      <DateInput source="bankTransaction.date" label="Date" validate={required()} />
      <ReferenceInput
        label="Product"
        source="product.id"
        reference="Product"
        filterToQuery={nameFilterToQuery}
        validate={required()}
      >
        <AutocompleteInput />
      </ReferenceInput>
      <FileInput source="uploads" label="Attachments" multiple>
        <FileField source="url" title="name" />
      </FileInput>
      <HiddenUserInput {...props} />
    </SimpleForm>
  </Edit>
)

export const ExpenseShow = props => (
  <Show title={<ExpenseTitle />} {...props}>
    <TabbedShowLayout>
      <Tab label="summary">
        <TextField source="id" />
        <TextField source="bankTransaction.name" label="Name" />
        <TextField source="type.name" label="Type" />
        <NumberField
          label="Amount"
          source="bankTransaction.amount"
          options={{ style: 'currency', currency: 'USD' }}
        />
        <TextField source="bankTransaction.description" label="Description" />
        <MultiDateField source="bankTransaction.date" label="Date" />
        <ResourceField
          reference="Product"
          source="product.name"
          target="product.id"
          label="Product"
        />
      </Tab>
      <Tab label="Attachments" path="attachments">
        <Attachments />
      </Tab>
    </TabbedShowLayout>
  </Show>
)
